import { useEffect, useState } from "react";
import useFirestore from "shared/hooks/useFirestore";
import useGetBranchId from "shared/hooks/useGetBranchId";

interface student{
    name:string,
    uid:string,
}

interface teacher{
    name:string,
    uid:string
}

interface lesson{
    name:string,
    id:string
}

const useStudentProfile = (student_uid:string) => {
    const {getBranchId} = useGetBranchId();
    const { readFirestoreWithQuery, readFirestoreOneDoc } = useFirestore();
    const [student, setStudent] = useState<student>({
        name:"",
        uid:""
    })
    const [teacher, setTeacher] = useState<teacher>({
        name:"",
        uid:""
    })
    const [lesson, setLesson] = useState<lesson>({
        name:"",
        id:""
    })
    

    useEffect(()=> {
        if(student_uid){
            getStudent();
            getLessonId();
        }
        // eslint-disable-next-line
    }, [student_uid])

    const getStudent = () => {
        readFirestoreOneDoc("User/Auth/Student", student_uid).then(res =>{
            if(res.exists()){
                const data = res.data();
                setStudent({
                    name:data.name,
                    uid:res.id
                })
            }
        })
    }

    const getTeacher = (teacher_uid:string) => {
        readFirestoreOneDoc("User/Auth/Teacher", teacher_uid).then(res => {
            if(res.exists()){
                const data = res.data();
                setTeacher({name:data.name, uid:res.id});
            }
        })
    }

    const getLessonId = async() => {
        const branch_id = await getBranchId();
        readFirestoreWithQuery(`Assign/${branch_id}/Lesson`, {field:"students", operator:"array-contains", data:student_uid}).then(res => {
            res.forEach((doc:any) => {
                getLesson(doc.id, branch_id);
            })
        })
    }

    const getLesson = async(lesson_id:string, branch_id:string) => {
        readFirestoreOneDoc(`Lesson/Branch/${branch_id}`, lesson_id).then(res => {
            if(res.exists()){
                const data = res.data();
                getTeacher(data.teacher);
                setLesson({name:data.name, id:res.id})
            }
        })
    }


    return {student, lesson, teacher};
}

export default useStudentProfile;